// @flow
import type {
  UsersById,
} from 'fc-model-users/types'

import {
  TREE,
  BRANCH,
} from '../constants'

// Utils
import traverse from 'fc-utils/traverse'
import emptyObject from 'fc-utils/emptyObject'

export default (traverse([TREE, BRANCH], {
  default: emptyObject,
}): Selector$<UsersById>)
